"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStaffs = exports.StaffValueFormatter = exports.getPerformerName = exports.getOwnerName = exports.getStaffNameAndDepartment = exports.StaffFormatValue = exports.getStaffNameAndEmailById = exports.getStaffNameAndEmail = exports.Level = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.Level = {
    ADMIN: 'ADMIN',
    NORMAL: 'NORMAL',
    UPLOADER: 'UPLOADER',
    WATCHER: 'WATCHER',
    BLOCKED: 'BLOCKED'
};
function getStaffNameAndEmail(staff) {
    if (!lodash_1.default.isEmpty(staff) && lodash_1.default.has(staff, 'name') && lodash_1.default.has(staff, 'email')) {
        return "".concat(staff === null || staff === void 0 ? void 0 : staff.name, " (").concat(staff === null || staff === void 0 ? void 0 : staff.email, ")");
    }
    return undefined;
}
exports.getStaffNameAndEmail = getStaffNameAndEmail;
function getStaffNameAndEmailById(staffs, id) {
    return getStaffNameAndEmail(lodash_1.default.find(staffs, { id: id })) || id;
}
exports.getStaffNameAndEmailById = getStaffNameAndEmailById;
function StaffFormatValue(staffs) {
    return function (value) {
        var staff = getStaffNameAndEmailById(staffs, value);
        return staff || value;
    };
}
exports.StaffFormatValue = StaffFormatValue;
function getStaffNameAndDepartment(staffs, id) {
    var staff = lodash_1.default.find(staffs, { id: id });
    if (!staff) {
        return id;
    }
    return "[".concat(staff.departmentName, "] ").concat(staff.name);
}
exports.getStaffNameAndDepartment = getStaffNameAndDepartment;
function getOwnerName(staffs, evaluation) {
    var _a;
    return ((_a = lodash_1.default.find(staffs, { id: evaluation === null || evaluation === void 0 ? void 0 : evaluation.state.owner })) === null || _a === void 0 ? void 0 : _a.name) || (evaluation === null || evaluation === void 0 ? void 0 : evaluation.state.owner) || '';
}
exports.getOwnerName = getOwnerName;
function getPerformerName(staffs, evaluation) {
    var _a;
    return (((_a = lodash_1.default.find(staffs, { id: evaluation === null || evaluation === void 0 ? void 0 : evaluation.state.performer })) === null || _a === void 0 ? void 0 : _a.name) || (evaluation === null || evaluation === void 0 ? void 0 : evaluation.state.performer) || '');
}
exports.getPerformerName = getPerformerName;
function StaffValueFormatter(staffs) {
    return function (params) {
        var value = lodash_1.default.get(params, 'value', '');
        var staff = getStaffNameAndEmailById(staffs, value);
        return staff || value;
    };
}
exports.StaffValueFormatter = StaffValueFormatter;
function filterStaffs(staffs, isOwner) {
    var levels = ['ADMIN', 'NORMAL'];
    if (isOwner) {
        levels.push('UPLOADER');
    }
    return (0, lodash_1.default)(staffs)
        .map(function (staff) { return (lodash_1.default.includes(levels, staff.level) ? staff : undefined); })
        .compact()
        .value();
}
exports.filterStaffs = filterStaffs;
//# sourceMappingURL=Staff.js.map